function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { CrumbType, PilePlacement, DEFAULT_PILE_AFTER_COUNT } from '../consts';
const useBreadcrumbs = _ref => {
  let {
    links,
    pilePlacement = PilePlacement.beginning,
    pileAfterCount = DEFAULT_PILE_AFTER_COUNT
  } = _ref;
  const breadcrumbs = useMemo(() => {
    const crumbs = links.map((link, index) => {
      const isActive = index + 1 === links.length;
      return _objectSpread({
        type: CrumbType.crumb,
        key: "".concat(link.label, "_").concat(index),
        'aria-current': isActive ? 'page' : undefined,
        isActive
      }, link);
    });
    if (links.length >= pileAfterCount) {
      switch (pilePlacement) {
        case PilePlacement.beginning:
          {
            const lastTwoCrumbs = crumbs.slice(crumbs.length - 2, crumbs.length);
            const crumbPile = {
              type: CrumbType.crumbPile,
              key: 'pile_beginning',
              breadcrumbs: crumbs.slice(0, crumbs.length - 2)
            };
            return [crumbPile, ...lastTwoCrumbs];
          }
        case PilePlacement.middle:
          {
            const firstCrumb = crumbs[0];
            const crumbPile = {
              type: CrumbType.crumbPile,
              key: 'pile_middle',
              breadcrumbs: crumbs.slice(1, crumbs.length - 1)
            };
            const lastCrumb = crumbs[crumbs.length - 1];
            return [firstCrumb, crumbPile, lastCrumb];
          }
        default:
          {
            return crumbs;
          }
      }
    }
    return crumbs;
  }, [links, pilePlacement, pileAfterCount]);
  return {
    breadcrumbs
  };
};
export default useBreadcrumbs;
//# sourceMappingURL=useBreadcrumbs.js.map